const state = {
  scope: null,
  serviceOrder: null,
}

export const getters = {
  serviceOrder: state => state.serviceOrder,
}

export const mutations = {
  setScope(state, scope) {
    state.scope = scope
  },

  setServiceOrder(state, serviceOrder) {
    state.serviceOrder = serviceOrder
  },

  clearServiceOrder(state) {
    state.serviceOrder = null
  },
}

export const actions = accountingService => ({
  async fetchServiceOrder({ commit, state }, id) {
    if (!state.scope) {
      throw new Error('Scope not set')
    }

    commit('clearServiceOrder')
    const serviceOrder = await accountingService.fetchServiceOrder(state.scope, id)
    commit('setServiceOrder', serviceOrder)
  },
})

export default accountingService => ({
  namespaced: true,
  state,
  getters,
  mutations,
  actions: actions(accountingService)
})
